import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const VoucherReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Generar voucher de una autorización
   */
  builder
    .addCase(Types.GET_VOUCHER_LOADING, (state) => {
      state.getVoucherLoading = true;
      state.getVoucherError = null;
    })
    .addCase(Types.GET_VOUCHER_SUCCESS, (state, action) => {
      const { getVoucherData } = action;
      state.getVoucherData = getVoucherData;
      state.getVoucherLoading = false;
      state.getVoucherError = null;
    })
    .addCase(Types.GET_VOUCHER_FAILURE, (state, action) => {
      const { getVoucherError } = action;
      state.getVoucherData = INITIAL_STATE.getVoucherData;
      state.getVoucherLoading = false;
      state.getVoucherError = getVoucherError;
    });

  /**
   * Generar voucher GMM de una autorización
   */
  builder
    .addCase(Types.GET_VOUCHER_GMM_LOADING, (state) => {
      state.getVoucherGmmLoading = true;
      state.getVoucherGmmError = null;
    })
    .addCase(Types.GET_VOUCHER_GMM_SUCCESS, (state, action) => {
      const { getVoucherGmmData } = action;
      state.getVoucherGmmData = getVoucherGmmData;
      state.getVoucherGmmLoading = false;
      state.getVoucherGmmError = null;
    })
    .addCase(Types.GET_VOUCHER_GMM_FAILURE, (state, action) => {
      const { getVoucherGmmError } = action;
      state.getVoucherGmmData = INITIAL_STATE.getVoucherGmmData;
      state.getVoucherGmmLoading = false;
      state.getVoucherGmmError = getVoucherGmmError;
    });
});
